import {inject, Injectable} from '@angular/core';
import {Config} from '@shared/config/config';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

  private config: Config | undefined;
  private http = inject(HttpClient)

  constructor() {}

  loadConfig(url: string): Promise<void> {
    return new Promise((resolve) => {
      this.http.get<Config>(url).pipe(map(res => res))
        .subscribe(config => {
          this.config = config;
          // @ts-ignore
          resolve();
        });
    });
  }

  get(): Config {
    return this.config!
  }
}
